import React from 'react';
import * as Yup from 'yup';
import Button from '../Button';
import FormField from '../FormField';
import { useEffect } from 'react';
import { usePrevious } from '../../utils/hooks';
import Currency from '../Currency';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { Formik } from 'formik';

const AvaluoForm = ({
  formik,
  avaluos,
  fetchAvaluos,
  toProperties,
  sendAvaluo,
}) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const previousFormikValues = usePrevious(formik.values);
  useEffect(() => {
    const keys = Object.keys(avaluos?.data || []);
    keys.forEach(x => {
      if (x === 'kms') {
        return;
      }
      if (!avaluos.data[x].length || avaluos.data[x].length > 1) return;
      formik.setFieldValue(x.substring(0, x.length - 1), avaluos.data[x][0]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avaluos.data]);

  useEffect(() => {
    const properties = toProperties(formik.values);
    const placa = previousFormikValues?.placa;
    const placaActual = properties?.placa;
    if (placaActual && placa !== placaActual) {
      return;
    }

    const estado = previousFormikValues?.estado;
    const estadoActual = properties?.estado;
    if (estadoActual && estado !== estadoActual) {
      return;
    }

    const kmP = previousFormikValues?.km;
    const kmActual = properties?.km;
    if (!!kmActual && kmP !== kmActual) {
      return;
    }

    const { km, ...rest} = properties;
    fetchAvaluos(rest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  const toModel = array => {
    return array.reduce((acc, curr) => {
      return [
        ...acc,
        {
          label: curr,
          value: curr,
        },
      ];
    }, []);
  };

  // const toModelKms = array => {
  //   return array.reduce((acc, curr) => {
  //     return [
  //       ...acc,
  //       {
  //         label: `${formatMoney(curr, 0)} kms`,
  //         value: curr,
  //       },
  //     ];
  //   }, []);
  // };
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="avaluo-form">
          <div className="avaluo-form__item" style={{ zIndex: 10 }}>
            <FormField
              label="Seleccione la placa"
              id="placa"
              name="placa"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.placa}
              touched={formik.touched.placa}
              error={formik.errors.placa}
              required
              customLabel={
                <>
                  <span className="red">*</span> Placa
                </>
              }
              options={toModel(avaluos?.data?.marcas || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 10 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="marca"
              name="marca"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.marca}
              touched={formik.touched.marca}
              error={formik.errors.marca}
              required
              customLabel={
                <>
                  <span className="red">*</span> Marca
                </>
              }
              options={toModel(avaluos?.data?.marcas || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 9 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="modelo"
              name="modelo"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.modelo}
              touched={formik.touched.modelo}
              error={formik.errors.modelo}
              required
              customLabel={
                <>
                  <span className="red">*</span> Modelo
                </>
              }
              options={toModel(avaluos?.data?.modelos || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 8 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="version"
              name="version"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.version}
              touched={formik.touched.version}
              error={formik.errors.version}
              required
              customLabel={
                <>
                  <span className="red">*</span> Version
                </>
              }
              options={toModel(avaluos?.data?.versions || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 7 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="anio"
              name="anio"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.anio}
              touched={formik.touched.anio}
              error={formik.errors.anio}
              required
              customLabel={
                <>
                  <span className="red">*</span> Año
                </>
              }
              options={toModel(avaluos?.data?.anios || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 6 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="km"
              name="km"
              type="number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.km}
              touched={formik.touched.km}
              error={formik.errors.km}
              required
              customLabel={
                <>
                  <span className="red">*</span> Kilometraje
                </>
              }
              // options={toModelKms(avaluos?.data?.kms || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 5 }}>
            <FormField
              label="Seleccione la marca"
              id="estado"
              name="estado"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.estado}
              touched={formik.touched.estado}
              error={formik.errors.estado}
              required
              customLabel={
                <>
                  <span className="red">*</span> Estado del vehículo
                </>
              }
              options={toModel(['Excelente', 'Bueno', 'Regular', 'Malo'])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 4 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="tipo"
              name="tipo"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.tipo}
              touched={formik.touched.tipo}
              error={formik.errors.tipo}
              required
              customLabel={
                <>
                  <span className="red">*</span> Tipo de vehículo
                </>
              }
              options={toModel(avaluos?.data?.tipos || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 3 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              label="Seleccione la marca"
              id="combustible"
              name="combustible"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.combustible}
              touched={formik.touched.combustible}
              error={formik.errors.combustible}
              required
              customLabel={
                <>
                  <span className="red">*</span> Combustible
                </>
              }
              options={toModel(avaluos?.data?.combustibles || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 2 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              id="transmision"
              name="transmision"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.transmision}
              touched={formik.touched.transmision}
              error={formik.errors.transmision}
              required
              customLabel={
                <>
                  <span className="red">*</span> Transmisión
                </>
              }
              options={toModel(avaluos?.data?.transmisions || [])}
            />
          </div>
          <div className="avaluo-form__item" style={{ zIndex: 2 }}>
            <FormField
              isLoading={avaluos?.isLoading}
              id="traccion"
              name="traccion"
              type="select"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.traccion}
              touched={formik.touched.traccion}
              error={formik.errors.traccion}
              required
              customLabel={
                <>
                  <span className="red">*</span> Tracción
                </>
              }
              options={toModel(avaluos?.data?.traccions || [])}
            />
          </div>
        </div>
        <span className="obligatory">* Campos obligatorios</span>
        {!avaluos?.currentAvaluo && (
          <div className="avaluo-buttons">
            <Button disabled={!formik.isValid} type="red">
              Calcular
            </Button>
            <Button
              onClick={e => {
                e.preventDefault();
                formik.resetForm();
                // Set an error field because formik sets the isvalid as true
                formik.setFieldError('marca', 'Requerido');
              }}
            >
              Borrar
            </Button>
          </div>
        )}
      </form>
      {avaluos?.currentAvaluo && (
        <>
          <div className="avaluo-buttons avaluo-buttons--price">
            <span>Monto de Avalúo aproximado: </span>
            <Button disabled={!formik.isValid} type="red">
              <Currency value={avaluos?.currentAvaluo?.precio} />
            </Button>
          </div>
          <div className="avaluo-buttons">
            <Button
              disabled={!formik.isValid}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Enviar por correo
            </Button>
            <Button
              onClick={e => {
                e.preventDefault();
                formik.resetForm();
                // Set an error field because formik sets the isvalid as true
                formik.setFieldError('marca', 'Requerido');
                setShowModal(false);
              }}
            >
              Borrar
            </Button>
          </div>
          {showModal && <div>
            <Formik
              initialValues={{
                nombre: '',
                email: '',
                telefono: '',
              }}
              validationSchema={Yup.object().shape({
                nombre: Yup.string().required('Requerido'),
                email: Yup.string()
                  .email('Ingrese un email válido')
                  .required('Requerido'),
                telefono: Yup.string().required('Requerido'),
              })}
              onSubmit={values => {
                sendAvaluo(toProperties(formik.values), values);
                history.push('/avaluo/gracias');
              }}
              validateOnMount={true}
            >
              {formik2 => (
                <form onSubmit={formik2.handleSubmit}>
                  <div
                    className="avaluo-form"
                    style={{ justifyContent: 'center' }}
                  >
                    <div className="avaluo-form__item" style={{ zIndex: 10 }}>
                      <FormField
                        label="Escribe tu nombre"
                        id="nombre"
                        name="nombre"
                        onChange={formik2.handleChange}
                        onBlur={formik2.handleBlur}
                        value={formik2.values.nombre}
                        touched={formik2.touched.nombre}
                        error={formik2.errors.nombre}
                        required
                        customLabel={
                          <>
                            <span className="red">*</span> Nombre
                          </>
                        }
                      />
                    </div>
                    <div className="avaluo-form__item" style={{ zIndex: 10 }}>
                      <FormField
                        label="Escribe tu telefono"
                        id="telefono"
                        name="telefono"
                        onChange={formik2.handleChange}
                        onBlur={formik2.handleBlur}
                        value={formik2.values.telefono}
                        touched={formik2.touched.telefono}
                        error={formik2.errors.telefono}
                        required
                        customLabel={
                          <>
                            <span className="red">*</span> Teléfono
                          </>
                        }
                      />
                    </div>
                    <div className="avaluo-form__item" style={{ zIndex: 10 }}>
                      <FormField
                        label="Escribe tu email"
                        id="email"
                        name="email"
                        onChange={formik2.handleChange}
                        onBlur={formik2.handleBlur}
                        value={formik2.values.email}
                        touched={formik2.touched.email}
                        error={formik2.errors.email}
                        required
                        customLabel={
                          <>
                            <span className="red">*</span> Email
                          </>
                        }
                      />
                    </div>
                    <div className="avaluo-buttons avaluo-buttons--flex avaluo-buttons--no-margin">
                      <Button disabled={!formik2.isValid} type="red">
                        Enviar
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>}
        </>
      )}
    </>
  );
};

export default AvaluoForm;
